import { RespostaOfertas } from "app/types/produto/RespostaOfertas";
import globalMU from "globalMU";
import React, { useState, useMemo } from "react";
import { Paginacao } from "../paginacao/Paginacao";

const estiloOfertas = require("./ofertas.module.scss").default;

export type OfertasProps = {
  produto: string;
  descricao: string;
  porGrupoDeOfertas?: boolean
  tratamentoDiferenciadoAtacado?: boolean // 456099
  permiteVisualizacaPorFilial: boolean
  permiteVisualizacaoOfertasClientes: boolean;
  dadosOfertas: RespostaOfertas
  onPesquisarPaginado: (numeroPagina: number) => void
};

export const Ofertas = (props: OfertasProps) => {
  const detalheProdutoSelecionado = useMemo(() => (
    <div className={estiloOfertas.form}
      id="ofertas_detalheProdutoSelecionado"
      key="detalheProdutoSelecionado"
    >
      <label
        title="Veja Parâmetros: &#013;- Utilizar grupos de produtos em oferta&#013;- Utiliza lista de oferta por área de vendas&#013;- Ocultar Ofertas Sem Quantidade Ofertada Disponível&#013;&#013;- Utiliza preço da Lista de Oferta&#013;- Lista de ofertas por filial&#013;- Utiliza lista de oferta por condição de pagamento&#013;- Utiliza lista de ofertas por plano de pagamento&#013;- Oferta seletiva"
      >Produto</label>
      <div>{props.produto}</div>

      <label>Descrição</label>
      <div>{props.descricao}</div>
    </div>
  ), [props.produto, props.descricao]);

  const paginacao = useMemo(() => 
    props.dadosOfertas?.Dados?.PageCount > 1 && (
      <Paginacao
        paginaAtual={props.dadosOfertas?.Dados?.ActualPage}
        totalPaginas={props.dadosOfertas?.Dados?.PageCount}
        id="ofertas_Paginacao"
        key="paginacao"
        onAlterarListaSelecionada={props.onPesquisarPaginado}
      />
    ), [props.dadosOfertas?.Dados, props.onPesquisarPaginado]);

  const ofertasLista = useMemo(() => {
    return props.dadosOfertas?.Dados?.Entities?.map((value, index) => {
      const informacoesOferta = (
        <div style={{ display: "flex", alignItems: "flex-start" }}
          id={`ofertas_info_${index}_${value?.Codigo}`}
          key={`ofertas_info_${index}`}
        >
          <div className={estiloOfertas.form}>
            <label>Data Inicial</label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_DataInicialValor`}
            >{globalMU.formatDate(value?.DataInicial)}</div>

            {props.porGrupoDeOfertas && <>
            <label>Horário Início</label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_HorarioInicioValor`}
            >{value?.HorarioInicio?.slice(0,5) ?? ""}</div>
            </>}

            <label>Preço Normal </label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_PrecoProdutoValor`}
            >{globalMU.formatarValorNumerico(value?.PrecoProduto, 2, true)}</div>

            <label>Preço de Oferta </label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_PrecoValor`}
            >{globalMU.formatarValorNumerico(value?.Preco, 2, true)}</div>

            {props.permiteVisualizacaoOfertasClientes && (
              <>
                <label
                  title="Veja parâmetro: Trabalha com oferta para clientes cadastrados"
                >Oferta para Clientes Cadastrados</label>
                <div
                  id={`ofertas_info_${index}_${value?.Codigo}_ClienteCadastradoValor`}
                >{value?.ClienteCadastrado ? "Sim" : "Não"}</div>
              </>
            )}

            {props.porGrupoDeOfertas && props.tratamentoDiferenciadoAtacado && // 456099
              <>
              <label
                id={`ofertas_info_${index}_${value?.Codigo}_PrecoAtacadoLabel`}
                title="Veja parâmetro: Oferta - Tratar valor diferenciado pela Quantidade vendida (Atacado)?"
              >Preço Atacado</label> 
              <div
                id={`ofertas_info_${index}_${value?.Codigo}_PrecoAtacadoValor`}
              >
                {globalMU.formatarValorNumerico(value?.PrecoAtacado, 2, true)}
              </div>
              </>
            }
            {props.porGrupoDeOfertas && props.tratamentoDiferenciadoAtacado && // 456099
              <>
              <label
                id={`ofertas_info_${index}_${value?.Codigo}_QuantidadeAtacadoLabel`}
                title="Veja parâmetro: Oferta - Tratar valor diferenciado pela Quantidade vendida (Atacado)?"
              >Quantidade Atacado</label> 
              
              <div
                id={`ofertas_info_${index}_${value?.Codigo}_QuantidadeAtacadoValor`}
              >{globalMU.formatarValorNumerico(value?.QuantidadeAtacado, 3)}
              </div>
              </>
            }

            <>
            <label
              id={`ofertas_info_${index}_${value?.Codigo}_OfertaVendasSobEncomendaLabel`}
            >Oferta Válida Somente para Vendas Sob Encomenda</label> 
            
            <div
               id={`ofertas_info_${index}_${value?.Codigo}_OfertaPercentualOfertaLabel`}
            >
              {value?.VendaSobEncomenda ? "Sim" : "Não"}  {/* 479547 */}
            </div>
            </>
        </div>

          <div className={estiloOfertas.form}
            id={`ofertas_info_${index}_${value?.Codigo}`}
          >
            <label
              id={`ofertas_info_${index}_${value?.Codigo}_DataFinalLabel`}
            >Data Final</label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_DataFinalValor`}
            >{globalMU.formatDate(value?.DataFinal)}</div>

            {props.porGrupoDeOfertas && <>
            <label
              id={`ofertas_info_${index}_${value?.Codigo}_HorarioTerminoLabel`}
            >Horário Término</label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_HorarioTerminoValor`}
            >{value?.HorarioTermino?.slice(0,5) ?? ""}</div>
            </>}

            <label
              id={`ofertas_info_${index}_${value?.Codigo}_QuantidadeOfertadaLabel`}
            >Quantidade Ofertada</label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_QuantidadeOfertadaValor`}
            >{globalMU.formatarValorNumerico(value?.QuantidadeOfertada, 3)}</div>

            <label title="Veja parâmetro: Ocultar Ofertas Sem Quantidade Ofertada Disponível"
              id={`ofertas_info_${index}_${value?.Codigo}_QuantidadeOfertadaVendidaLabel`}
            > Quantidade Ofertada Vendida </label>
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_QuantidadeOfertadaVendidaValor`}
            >{globalMU.formatarValorNumerico(value?.QuantidadeVendida, 3)}</div>

            {props.porGrupoDeOfertas && //438891	
            <>
            <label
              id={`ofertas_info_${index}_${value?.Codigo}_VendaIdentificadaLabel`}
              title="Oferta será válida somente se o orçamento tiver o cliente informado"
            >Oferta Válida Somente para Venda Identificada</label> 
            <div
              id={`ofertas_info_${index}_${value?.Codigo}_VendaIdentificadaValor`}
            >{value?.VendaIdentificada ? "Sim" : "Não"}</div>
            </>
            }
          </div>
        </div>
      );

      const tabelaCondicaoPagamento = (
        <table className="_table _w-full _border-collapse"
          id={`ofertas_tabelaCondicaoPagamento_${index}_${value?.Codigo}`}
          key={`ofertas_tabelaCondicaoPagamento_${index}_${value?.Codigo}`}
        >
          <thead>
            <tr>
              <th className={`_table-cell ${estiloOfertas.tableCellHeader}`}
                id={`ofertas_tabelaCondicao_Header_${index}_${value?.Codigo}`}
              >
                Condição de Pagamento
              </th>
              <th className={`_table-cell ${estiloOfertas.tableCellHeader}`}
                id={`ofertas_tabelaCondicao_Header_PercDesconto_${index}_${value?.Codigo}`}
                style={{ width: '90px' }}
              >
                % Desconto
              </th>
              {props.dadosOfertas.MostrarTipoDocumento && (
                <th 
                  className={`_table-cell ${estiloOfertas.tableCellHeader}`} 
                  id={`ofertas_tabelaCondicao_Header_TipoDocumento_${index}_${value?.Codigo}`}
              >Tipo de Documento</th>
              )}
            </tr>
          </thead>
          <tbody
            id={`ofertas_tabelaCondicao_Dados_${index}_${value?.Codigo}`}
          >
            {value.FormasPagamento?.map((formaPagamento, indexFormaPagamento) => (
              <tr
                key={`${index}_${indexFormaPagamento}`}
                id={`ofertas_tabelaCondicao_Dados_${indexFormaPagamento}_${value?.Codigo}`}
                className={`_table-row ${estiloOfertas.tableBody}`}
              >
                <td
                  id={`ofertas_tabelaCondicao_Dados_CondicaoPagamento_${indexFormaPagamento}_${value?.Codigo}`}
                  className={`_table-cell ${estiloOfertas.tableCellBody}`}
                >
                  {formaPagamento.Nome}
                </td>
                <td
                  id={`ofertas_tabelaCondicao_Dados_PercDesconto_${index}_${indexFormaPagamento}_${value?.Codigo}`}
                  className={`_table-cell ${estiloOfertas.tableCellBody}`}
                  style={{ width: '90px', textAlign: 'right' }}
                > 
                  {formaPagamento.PercentualDesconto && formaPagamento.PercentualDesconto > 0   
                    ? globalMU.formatarValorNumerico(formaPagamento?.PercentualDesconto, 2, false)  // 479547
                    : null
                }
                </td>
                {props.dadosOfertas.MostrarTipoDocumento && (
                  <td
                    className={`_table-cell ${estiloOfertas.tableCellBody}`}
                    id={`ofertas_tabelaCondicao_Dados_TipoDocumento_${indexFormaPagamento}_${value?.Codigo}`}
                    key={`tipoDoc_${indexFormaPagamento}_${value?.Codigo}`}
                  >
                    {formaPagamento.NomeTipoDocumento}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      );

      const tabelaFilial = value?.Filiais?.length > 0 && (
        <table className="_table _w-full _border-collapse"
          id={`ofertas_tabelaFilial_${index}_${value?.Codigo}`}
          key={`ofertas_tabelaFilial_${index}_${value?.Codigo}`}
        >
          <thead
            id={`ofertas_tabelaFilial_Cabecalho_${index}_${value?.Codigo}`}
          >
            <tr>
              <th
                className={`_table-cell ${estiloOfertas.tableCellHeader}`}
              >
                Filial
              </th>
              {props.permiteVisualizacaPorFilial && (
                <th
                  title="Veja parâmetro: Lista de ofertas por filial"
                  className={`_table-cell ${estiloOfertas.tableCellHeader}`}
                  id={`ofertas_tabelaFilial_PrecocellHeader_${index}_${value?.Codigo}`}
                  key="precoHeader"
                >
                  Preço
                </th>
              )}
            </tr>
          </thead>
          <tbody
            id="ofertas_tabelaFilial_Dados"
          >
            {value.Filiais?.map((filial, indexFilial) => (
              <tr
                key={`Filial_${index}_${value?.Codigo}_${indexFilial}`}
                className={`_table-row ${estiloOfertas.tableBody}`}
              >
                <td
                  className={`_table-cell ${estiloOfertas.tableCellBody}`}
                >
                  {filial.Descricao}
                </td>
                {props.permiteVisualizacaPorFilial && (
                  <td
                    className={`_table-cell ${estiloOfertas.tableCellBody}`}
                    id={`ofertas_tabelaFilial_PrecoValor_${index}_${value?.Codigo}_${indexFilial}`}
                    key={`precoValor_${indexFilial}`}
                  >
                    {globalMU.formatarValorNumerico(filial.Preco, 3)}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      );

      const tabelaClientesPromocao = value?.ClientesPromocao?.length > 0 && (
        <table className="_table _w-full _border-collapse"
          id={`ClientesPromocao_${index}_${value?.Codigo}`}
          key={`ClientesPromocao_${index}_${value?.Codigo}`}
        >
          <thead>
            <tr>
              <th className={`_table-cell ${estiloOfertas.tableCellHeader}`} key="cpfCnpjHeader">Cpf/Cnpj</th>
              <th className={`_table-cell ${estiloOfertas.tableCellHeader}`} key="clienteHeader">Cliente</th>
            </tr>
          </thead>
          <tbody>
            {value?.ClientesPromocao?.map((cliente, indexCliente) => (
              <tr
                key={`ClientesPromocao_${index}_${value?.Codigo}_${indexCliente}`}
                className={`_table-row ${estiloOfertas.tableBody}`}
                id={`ClientesPromocao_${index}_${value?.Codigo}_${indexCliente}`}
              >
                <td className={`_table-cell ${estiloOfertas.tableCellBody}`}
                  id={`ClientesPromocao_CpfCnpj_${index}_${value?.Codigo}_${indexCliente}`}
                  key={`cpfCnpj_${indexCliente}`}
                >{cliente.CpfCnpj}</td>
                <td className={`_table-cell ${estiloOfertas.tableCellBody}`}
                  id={`ClientesPromocao_Cliente_${index}_${value?.Codigo}_${indexCliente}`}
                  key={`cliente_${indexCliente}`}
                >{cliente.Nome}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );

      return (
        <details key={`oferta_${index}_${value?.Codigo}`} className={estiloOfertas.ofertaDetails}>
          <summary className={estiloOfertas.ofertaSummary}>
            <h4 style={{ fontSize: "16px", margin: 0 }}
              id={`ofertas_summary_${index}_${value?.Codigo}`}
            >
              {value?.Descricao}
            </h4>
          </summary>
          <div className={estiloOfertas.fundoBranco}>
            {informacoesOferta}
            <br />
            {tabelaCondicaoPagamento}
            <br />
            {tabelaFilial && (
              <>
                {tabelaFilial}
                <br />
              </>
            )}
            {tabelaClientesPromocao}
          </div>
        </details>
      );
    });
  }, [props.dadosOfertas, props.porGrupoDeOfertas, props.tratamentoDiferenciadoAtacado, props.permiteVisualizacaPorFilial, props.permiteVisualizacaoOfertasClientes]);

  return (
    <div key="ofertasContainer">
      {detalheProdutoSelecionado}
      <br />
      {ofertasLista}
      {paginacao}
      <section style={{ marginBottom: "100px" }} key="spacer" />
    </div>
  );
};